module.exports = __webpack_public_path__ + "img/slice-bg.a2adc5a7.png";